export const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (custom = 0) => ({
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.8,
            ease: [0.22, 1, 0.36, 1], // Custom bezier for "Apple-like" feel
            delay: custom * 0.1
        }
    })
};

export const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            delayChildren: 0.2
        }
    }
};

export const scaleOnHover = {
    initial: { scale: 1 },
    hover: {
        scale: 1.02,
        transition: { duration: 0.4, ease: "easeOut" }
    },
    tap: { scale: 0.98 }
};

export const pageTransition = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.6, ease: "easeInOut" } },
    exit: { opacity: 0, transition: { duration: 0.4 } }
};
